import { Provider } from 'react-redux';
import './App.css';
import Cart from './components/Cart';
import ProductContainer from './components/ProductContainer';
import TotalItem from './components/TotalItem';
import TotalPrice from './components/TotalPrice';
import store from './redux/store';
// const products = [
//   { name: "Asus Vivobook X515MA", price: 35500, availableStock: 20 },
//   { name: "Dell E1916HV 18.5 Inch", price: 9300, availableStock: 35 },
//   { name: "Canon Eos 4000D 18MP", price: 36500, availableStock: 72 },
// ]

function App() {
  // const products = useSelector(state => state.productStore)
  return (
    <Provider store={store}>
      <div className="bg-gray-50 h-full md:h-screen">
        <div className="grid place-items-center">
          <h1
            className="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4"
          >
            Shopping Cart
          </h1>
        </div>
        <div className="grid grid-cols-12 gap-6">
          <ProductContainer />
          <div
            className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4"
          >
            <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
              <Cart />
              <TotalItem />
            </div>
            <TotalPrice />
          </div>
        </div>
      </div >
    </Provider>
  );
}

export default App;
